export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';
export const REQUEST_ADMIN_HOST = 'REQUEST_ADMIN_HOST';
export const REQUEST_APP_STORE_PATH = 'REQUEST_APP_STORE_PATH';
export const REDIRECT_TO_INNER_PATH = 'REDIRECT_TO_INNER_PATH';
